import { render, staticRenderFns } from "./PlanejamentoAlojamentoCard.vue?vue&type=template&id=5e655b04&scoped=true&"
import script from "./PlanejamentoAlojamentoCard.vue?vue&type=script&lang=js&"
export * from "./PlanejamentoAlojamentoCard.vue?vue&type=script&lang=js&"
import style0 from "./PlanejamentoAlojamentoCard.vue?vue&type=style&index=0&id=5e655b04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e655b04",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VChip,VCol,VContainer,VIcon,VRow})
